import dayjs from 'dayjs';

const _LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS = 'le_localstorage_hotel_search_params';
const _SESSION_KEY_MASTER_AIRPLANE_TICKET = 'le_session_master_airplane_ticket';

export default class Util {
  static BREAK_POINT = 900;

  static get isSp() {
    return Util.getWindowSize().w <= Util.BREAK_POINT;
  }

  static get isTouch() {
    return ('ontouchstart' in window);
  }

  /**
   * ローカルストレージ ホテル 検索結果保持用key
   * @example
   * //get
   * Util.LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS;
   * @return {String}
   */
  static get LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS() {
    return _LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS;
  }

  static get SESSION_KEY_MASTER_AIRPLANE_TICKET() {
    return _SESSION_KEY_MASTER_AIRPLANE_TICKET;
  }

  static getWindowSize() {
    let r = (window.devicePixelRatio)? window.devicePixelRatio : 1;
    let w = Util.getWindowWidth();
    let h = window.innerHeight;
    return {w:w,h:h,r:r};
  }

  static getWindowWidth(isScrollWidth = false) {
    let w = window.innerWidth;
    if(isScrollWidth) w -= Util.getWindowScrollWidth();
    return w;
  }

  static getWindowScrollWidth() {
    if(!document.body) return 0;
    let scrollbarElem = document.createElement('div');
    scrollbarElem.setAttribute('style', 'visibility: hidden; position: absolute; top: 0; left: 0; width: 100vw;');
    document.body.appendChild(scrollbarElem);
    let vw = parseInt(window.getComputedStyle(scrollbarElem).width);
    scrollbarElem.style.width = '100%';
    let pc = parseInt(window.getComputedStyle(scrollbarElem).width);
    document.body.removeChild(scrollbarElem);
    return vw - pc;
  }

  static getScrollY() {
    return (window.scrollY == null)? document.documentElement.scrollTop : window.scrollY;
  }

  static setAnchor(_target = document) {
    _target.querySelectorAll('a[href^="#"]').forEach(item=>{
      item.addEventListener("click",e=>{
        e.preventDefault();
        const href = item.getAttribute("href");
        const target = (href==="#")? document.body : document.querySelector(href);
        if(target) {
          Util.runScroll(target);
        }
      });
    });
  }

  static runScroll(_target) {
    _target.scrollIntoView({behavior:"smooth",block:"start",inline:"nearest"});
  }

  static checkItems(items) {
    if(Array.isArray(items)) {
      return items;
    } else if(typeof items === "undefined" || !items) {
      return [];
    } else {
      return [items];
    }
  }

  static stripHtml(html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');
    return doc.body.textContent || "";
  }

  static getDayName(_day) {
    return ['日', '月', '火', '水', '木', '金', '土'][_day];
  }

  /*
  Dateから文字列変換
  data -> yyyy/mm/dd
   */
  static formatDate(date) {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // 月は0始まり
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}/${mm}/${dd}`;
  }

  /*
  文字列からDate変換
  yyyy/mm/dd -> data
   */
  static formatStringToDate(str) {
    const year = parseInt(str.substring(0, 4));
    const month = parseInt(str.substring(4, 6)) - 1;
    const day = parseInt(str.substring(6, 8));

    return new Date(year, month, day);
  }

  /*
  表示文字から送信文字に変換
  yyyy/mm/dd -> yyyymmdd
   */
  static formatStringToPostString(str) {
    return str.replace(/\//g, "");
  }

  /*
  +2営業日
   */
  static addBusinessDays(startDate, businessDays) {
    const date = new Date(startDate);
    let addedDays = 0;

    while (addedDays < businessDays) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();

      // 0: 日曜, 6: 土曜 → スキップ
      if (day !== 0 && day !== 6) {
        addedDays++;
      }
    }

    return date;
  }

  /**
   * ローカルストレージ 取得
   * @param {String} _key
   */
  static localstrageGetItem(_key) {
    if (LtikeCommon.API.DISABLE_CACHE || !window.localStorage) {
      return;
    }
    const _val = window.localStorage.getItem(_key);
    console.log('📖 Load "' + _key + '" from 📙 LocalStorage:', JSON.parse(_val));
    return _val;
  }

  /**
   * ローカルストレージ設定
   * @param {String} _key
   * @param {String} _val
   */
  static localstrageSetItem(_key, _val) {
    if (LtikeCommon.API.DISABLE_CACHE || !window.localStorage) {
      return;
    }
    console.log('💾 Save "' + _key + '" to 📙 LocalStorage: ', JSON.parse(_val));
    window.localStorage.setItem(_key, _val);
  }

  /**
   * セッションストレージ取得
   * @param {String} _key
   */
  static sessionStorageGetItem(_key) {
    if (LtikeCommon.API.DISABLE_CACHE || !window.sessionStorage) {
      return;
    }
    const _val = window.sessionStorage.getItem(_key);
    console.log('📖 Load "' + _key + '" from 📘 SesionStorage: ', JSON.parse(_val));
    return _val;
  }

  /**
   * セッションストレージ設定
   * @param {String} _key
   * @param {String} _val
   */
  static sessionStorageSetItem(_key, _val) {
    if (LtikeCommon.API.DISABLE_CACHE || !window.sessionStorage) {
      return;
    }
    console.log('💾 Save "' + _key + '" to 📘 SesionStorage :', JSON.parse(_val));
    window.sessionStorage.setItem(_key, _val);
  }

  /**
   * DefaultのCheckin,Checkout日付取得
   * @param {String} syflg
   *
   */
  static getDefaultSettingDate(_flag) {
    var defaultDate = {
      going: '',
      back: '',
    };

    if (_flag === 'dp') {
      let plus_date = LtikeCommon.DP.DEFAULT_DATE;
      defaultDate = {
        going: dayjs().add(plus_date.going, 'd').format('YYYYMMDD'),
        back: dayjs().add(plus_date.back, 'd').format('YYYYMMDD'),
      };
    } else if (_flag === 'hotel') {
      let startDefault = dayjs().format('YYYYMMDD');
      var goingCount = LtikeCommon.HOTEL.DEFAULT_DATE.going;
      let topJson = JSON.parse(Util.sessionStorageGetItem(Util.SESSION_KEY_MASTER_AIRPLANE_TICKET));
      for (let i = 0; i < topJson.calender.length; i++) {
        if (dayjs(topJson.calender[i].settingdate).diff(startDefault, 'day') > 0 && topJson.calender[i].businessdayflag === '1') {
          goingCount--;
        }
        if (goingCount === 0) {
          defaultDate.going = topJson.calender[i].settingdate;
          defaultDate.back = dayjs(defaultDate.going).add(1,'d').format('YYYYMMDD');
          break;
        }
      }
    } else if (_flag === 'flight') {
      let plus_date = LtikeCommon.AIRPLANE.DEFAULT_DATE;
      defaultDate = {
        going: dayjs().add(plus_date.going, 'd').format('YYYYMMDD'),
        back: dayjs().add(plus_date.back, 'd').format('YYYYMMDD'),
      };
    }

    return defaultDate;
  }

  /**
   * ホテル詳細の再検索URL取得
   * @param {string} url
   * @param {Date} alertdatetime
   */
  static getHotelsDetailSearchUrl(url, alertdatetime) {
    let reTime = new Date();
    let currentUrl = new URL(url, window.location.href);
    let going = currentUrl.searchParams.get('checkindate') || '';
    let back = currentUrl.searchParams.get('checkoutdate') || '';

    if (dayjs(alertdatetime.setMinutes(alertdatetime.getMinutes() - 30)).hour() < 17 && dayjs(reTime).hour() >= 17) {
      let default_date = Util.getDefaultSettingDate('hotel');
      let topJson = JSON.parse(Util.sessionStorageGetItem(Util.SESSION_KEY_MASTER_AIRPLANE_TICKET));
      let currentGoing = going;
      let currentBack = back;
      for (let i = 0; i < topJson.calender.length; i++) {
        if (dayjs(topJson.calender[i].settingdate).diff(currentGoing, 'day') > 0 && topJson.calender[i].businessdayflag === '1') {
          going = topJson.calender[i].settingdate;
          break;
        }
      }

      if (dayjs(default_date.going).diff(currentGoing,'d') === 0 && dayjs(default_date.back).diff(currentBack,'d') === 0) {
        back = dayjs(going).add(1, 'd').format('YYYYMMDD');
      } else if (dayjs(default_date.going).diff(currentGoing,'d') === 0 && dayjs(default_date.back).diff(currentBack,'d') > 0) {
        if (dayjs(currentBack).diff(going,'d') > 0) {
          back = dayjs(currentBack).format('YYYYMMDD');
        } else {
          back = dayjs(going).add(1, 'd').format('YYYYMMDD');
        }
      } else {
        going = dayjs(currentGoing).format('YYYYMMDD');
        back = dayjs(currentBack).format('YYYYMMDD');
      }

      let searchParams = Util.localstrageGetItem(Util.LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS);
      if (searchParams) {
        searchParams = JSON.parse(searchParams);
        searchParams.date.going = going;
        searchParams.date.back = back;
        Util.localstrageSetItem(Util.LOCALSTORAGE_KEY_HOTEL_SEARCH_PARAMS, JSON.stringify(searchParams));
      }
    } else {
      going = dayjs(going).format('YYYYMMDD');
      back = dayjs(back).format('YYYYMMDD');
    }

    currentUrl.searchParams.set('checkindate', dayjs(going).format('YYYYMMDD'));
    currentUrl.searchParams.set('checkoutdate', dayjs(back).format('YYYYMMDD'));

    return currentUrl.pathname + currentUrl.search + currentUrl.hash;
  }

  static getChdList(passengers) {
    var input = [];
    var adtnum = passengers.length;

    for (let i = 0; i < adtnum; i++) {
      const r = passengers[i];

      input.push('adtnum' + (i + 1) + '=' + r.adult);

      if (r.ageList !== undefined) {
        var chdnum = 0;
        var infnum = 0;
        var chdage = [];
        var infage = [];
        var checkageList = decodeURIComponent(r.ageList).split(',');

        for (var age = 0; age < checkageList.length; age++) {
          if (checkageList[age].length > 0 && checkageList[age] !== '') {
            if (Number(checkageList[age]) >= 2) {
              chdnum = chdnum + 1;
              chdage.push(checkageList[age]);
            } else {
              infnum = infnum + 1;
              infage.push(checkageList[age]);
            }
          }
        }

        if (chdnum > 0) {
          input.push('chdnum' + (i + 1) + '=' + chdnum);
          input.push('chdage' + (i + 1) + '=' + chdage.join(','));
        }
        if (infnum > 0) {
          input.push('infnum' + (i + 1) + '=' + infnum);
          input.push('infage' + (i + 1) + '=' + infage.join(','));
        }
      }
    }
    input.push('roomnum=' + adtnum);

    return input;
  }
  
  static getSearchParams() {
    return new URLSearchParams(location.search);
  }

  static setSearchParams(obj, clearPatterns = []) {
    const params = this.getSearchParams();

    // まずあらかじめ削除すべきキーを消す
    clearPatterns.forEach(pattern => {
      if (pattern instanceof RegExp) {
        [...params.keys()].forEach(key => {
          if (pattern.test(key)) params.delete(key);
        });
      } else {
        params.delete(pattern);
      }
    });

    Object.entries(obj).forEach(([key, value]) => {
      if (value === null || typeof value === 'undefined' || value === '') {
        params.delete(key);
      } else if (Array.isArray(value)) {
        params.set(key, value.join(','));
      } else {
        params.set(key, value);
      }
    });

    const queryString = params.toString();
    history.replaceState(null, '', queryString ? '?' + queryString : window.location.pathname + window.location.hash);
    return params;
  }

}
